import s from "./primitives.module.css";

/** The shape of the thing that is coming. Used everywhere a view is `degraded`, and never as a decoration: a
 *  view renders as DATA only when its seed has landed, because a live socket applying frames onto an empty base
 *  looks exactly like a calm market — the most expensive ambiguity in this client.
 *
 *  Sizes are CLASSES, not an inline `style` object. React's `style` prop emits a `style="…"` ATTRIBUTE, and the
 *  CSP is `style-src 'self'` with no `'unsafe-inline'` — which blocks attributes as well as `<style>` elements.
 *  A primitive that only works with a relaxed policy is how the policy gets relaxed. */
export type SkeletonVariant = "text" | "title" | "row" | "block" | "chart";

export function Skeleton({ variant = "text" }: { variant?: SkeletonVariant }) {
  return <span className={[s.skeleton, s[`sk_${variant}`]].join(" ")} aria-hidden="true" />;
}
